import React from 'react';
import styled from 'styled-components';
import { FaWhatsapp, FaEnvelope, FaPhone } from 'react-icons/fa';
import {
  WHATSAPP_GROUP_URL,
  mailtoHref,
  PUBLIC_EMAIL,
  telHref,
  PUBLIC_PHONE_DISPLAY,
} from '../../constants/publicContact';

const FooterRoot = styled.footer`
  display: none;

  @media (max-width: 1023px) {
    display: block;
    flex-shrink: 0;
    margin-top: auto;
    padding: ${({ theme }) => theme.semantic.space.md} ${({ theme }) => theme.semantic.space.lg}
      calc(${({ theme }) => theme.semantic.space.md} + env(safe-area-inset-bottom, 0px));
    border-top: 1px solid ${({ theme }) => theme.semantic.color.border.subtle};
    background: ${({ theme }) => theme.semantic.color.surface.page};
  }
`;

const FooterGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.primitives.space[1]};
`;

const FooterLink = styled.a`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.semantic.space.sm};
  min-height: 44px;
  color: ${({ theme }) => theme.semantic.color.text.primary};
  text-decoration: none;
  font-size: ${({ theme }) => theme.primitives.fontSize.sm};
  transition: color ${({ theme }) => theme.primitives.duration.fast}
    ${({ theme }) => theme.primitives.easing.ease};

  &:hover {
    color: ${({ theme }) => theme.semantic.color.brand.primary};
  }

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.semantic.focusRing};
    border-radius: ${({ theme }) => theme.primitives.radius.xs};
  }
`;

const IconWrap = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${({ theme }) => theme.semantic.color.brand.primary};

  svg {
    width: ${({ theme }) => theme.primitives.fontSize.md};
    height: ${({ theme }) => theme.primitives.fontSize.md};
  }
`;

const FooterLinkLabel = styled.span`
  min-width: 0;
  word-break: break-word;
`;

/**
 * Sticky contact rail at the bottom of the mobile navigation drawer.
 */
const MobileDrawerFooter: React.FC = () => {
  return (
    <FooterRoot>
      <FooterGrid>
        <FooterLink href={WHATSAPP_GROUP_URL} target="_blank" rel="noopener noreferrer">
          <IconWrap aria-hidden>
            <FaWhatsapp />
          </IconWrap>
          <FooterLinkLabel>Grupo WhatsApp</FooterLinkLabel>
        </FooterLink>
        <FooterLink href={mailtoHref}>
          <IconWrap aria-hidden>
            <FaEnvelope />
          </IconWrap>
          <FooterLinkLabel>{PUBLIC_EMAIL}</FooterLinkLabel>
        </FooterLink>
        <FooterLink href={telHref}>
          <IconWrap aria-hidden>
            <FaPhone />
          </IconWrap>
          <FooterLinkLabel>{PUBLIC_PHONE_DISPLAY}</FooterLinkLabel>
        </FooterLink>
      </FooterGrid>
    </FooterRoot>
  );
};

export default MobileDrawerFooter;
